import styled from 'styled-components';

export const Container = styled.div``;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Head = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
  flex-direction: column;
`;
export const Div = styled.div``;
export const Text = styled.p``;
